export const it = {
    translation: {
        common: {
            trial: "Versione di Prova",
            expired: "Scaduto",
            renewal: "Rinnovo",
            quantity: "Qtà",
            error: "Errore",
            all: "Tutti",
            loading: "Caricamento...",
            thank_you: "Grazie",
            confirm: "Conferma",
            cancel: "Annulla",
            save: "Salva",
            add: "Aggiungi",
            edit: "Modifica",
            delete: "Elimina",
            warning: "Attenzione",
            delete_confirm_text: "Questa azione non può essere annullata. Sei sicuro di voler eliminare?",
            click_to_select: "Seleziona...",
            unit: "Unità",
            detail: "Dettaglio",
            done: "Fatto",
            search: "Cerca",
            processing: "In corso...",
            success: "Successo",
            total: "Totale",
            none: "Nessuno"
        },
        roles: {
            admin: "Admin",
            barista: "Barista",
            waiter: "Cameriere",
            kitchen: "Cucina"
        },
        auth: {
            user_not_found: "Utente non trovato!",
            welcome: "Bentornato",
            subtitle: "Accedi per gestire la tua caffetteria",
            google_login: "Accedi con Google",
            apple_login: "Accedi con Apple",
            secure_login: "Accesso Sicuro",
            terms_text: "Accedendo, accetti i nostri Termini di Servizio e l'Informativa sulla Privacy."
        },
        sidebar: {
            dashboard: "Dashboard",
            tables: "Tavoli",
            staff: "Personale",
            loyalty: "CRM e Fedeltà",
            qr_menu: "Menu QR",
            menu_product: "Menu e Prodotti",
            stock_recipe: "Magazzino e Ricette",
            reports: "Rapporti",
            settings: "Impostazioni",
            admin_panel: "Pannello Admin",
            not_logged_in: "Non connesso",
            click_to_select: "Seleziona Profilo",
            switch_profile: "Cambia Profilo",
            logout: "Logout"
        },
        dashboard: {
            overview: "Panoramica Dashboard",
            today: "Oggi",
            system_active: "Sistema Attivo",
            offline: "Modalità Offline",
            payment_reminder: "Promemoria Pagamento",
            payment_missing_list: "Il pagamento per {{names}} non è ancora stato effettuato.",
            add_expense: "Aggiungi Spesa",
            daily_revenue: "Entrate Giornaliere",
            open_tables: "Tavoli Aperti",
            pending_tables: "Ordini in Sospeso",
            waiting_approval: "In attesa di approvazione",
            active_staff: "Personale Attivo",
            hourly_revenue: "Entrate Orarie",
            hourly_profit: "Utile Orario",
            work_hours: "Ore di Lavoro",
            hours_24: "24 Ore",
            revenue: "Entrate",
            profit: "Utile",
            best_sellers: "I più venduti",
            support_modal: { other: "Altro" },
            weekly_performance: "Performance Settimanale",
            weekly_revenue: "Entrate Settimanali",
            increase: "Aumento",
            decrease: "Diminuzione",
            busiest_day: "Giorno più impegnativo",
            view_report: "Visualizza Rapporto",
            critical_stock_warning: "Scorte Critiche",
            quick_actions: "Azioni Rapide",
            x_report: "Rapporto X",
            sync: "Sincronizza",
            backup: "Backup",
            support: "Supporto",
            help_support: "Aiuto e Supporto",
            help_desc: "Come possiamo aiutarti?",
            report_issue: "Segnala un problema",
            version: "Versione",
            topic: "Argomento",
            technical: "Problema Tecnico",
            suggestion: "Suggerimento",
            other: "Altro",
            description: "Descrizione",
            desc_placeholder: "Descrivi il problema...",
            send_report: "Invia Segnalazione"
        },
        tables: {
            status: {
                occupied: "Occupato",
                paid: "Pagato",
                reserved: "Riservato",
                empty: "Libero"
            },
            alerts: {
                reservation_time: "Orario Prenotazione:",
                draft_paid: "Bozza Ordine Pagata",
                draft_unpaid: "Bozza Ordine"
            },
            title: "Piano Tavoli",
            tabs: {
                plan: "Pianta",
                history: "Cronologia"
            },
            filter: {
                all: "Tutti"
            },
            actions: {
                finish_edit: "Termina Modifica",
                edit: "Modifica Tavoli",
                add_table: "Aggiungi Tavolo",
                quick_pay: "Pagamento Rapido",
                reserve: "Prenota",
                clear: "Libera"
            },
            card: {
                capacity: "Persone",
                just_now: "Proprio ora",
                total: "Totale",
                has_request: "Nuova Richiesta",
                no_order: "Nessun Ordine"
            },
            history: {
                search_placeholder: "Cerca Numero Scontrino o Tavolo...",
                multi_pay: "Pagamento Multiplo"
            },
            sections: {
                manage: "Gestisci Sezioni",
                add_placeholder: "Nome Nuova Sezione",
                no_sections: "Nessuna sezione definita."
            },
            modal: {
                edit_title: "Modifica Tavolo",
                add_title: "Aggiungi Tavolo",
                name: "Nome Tavolo",
                name_placeholder: "es. Tavolo 5",
                section: "Sezione",
                capacity: "Capacità",
                delete: "Elimina Tavolo",
                unpaid_warning_title: "Saldo non pagato!",
                clear_confirm_title: "Liberare Tavolo?",
                unpaid_warning_text: "<b>{{name}}</b> ha un saldo non pagato. Liberarlo resetterà l'ordine.",
                clear_confirm_text: "Sei sicuro di voler liberare il <b>{{name}}</b>?",
                delete_confirm_text: "Sei sicuro di voler eliminare il <b>{{name}}</b>?"
            },
            qr_review: {
                title: "Ordine QR in Arrivo",
                subtitle: "Nuova richiesta da {{name}}",
                current_state: "Stato Attuale Tavolo",
                table_empty: "Il tavolo è attualmente vuoto.",
                current_total: "Totale Attuale",
                incoming_request: "Richiesta in Arrivo",
                extra_total: "Totale Extra",
                reject: "Rifiuta",
                overwrite: "Sovrascrivi",
                overwrite_desc: "Pulisci attuale e imposta nuovo",
                merge: "Unisci",
                merge_desc: "Aggiungi all'esistente"
            }
        },
        orders: {
            status: {
                completed: "Completato"
            },
            list: {
                ticket_no: "Scontrino N.",
                date: "Data/Ora",
                table: "Tavolo/Cliente",
                method: "Metodo",
                amount: "Importo",
                status: "Stato"
            },
            modal: {
                match_error: "Il totale del pagamento ({{pay}}₺) non corrisponde al totale dell'ordine ({{total}}₺).",
                title: "Dettagli Transazione",
                content_title: "Contenuto Ordine",
                total_title: "Importo Totale",
                payment_details: "Dettagli Pagamento",
                entered_total: "Totale Inserito",
                difference: "Differenza"
            },
            correction: {
                note_placeholder: "es. Inserimento errato del personale"
            },
            void_flow: {
                button_update: "Aggiorna Stato / Storna",
                button_void: "Storno / Rimborso",
                title_select: "Seleziona Tipo di Storno",
                type_cancel: "Errore / Reso",
                type_cancel_desc: "Ripristina Magazzino",
                type_wastage: "Spreco / Rovesciato",
                type_wastage_desc: "Scarica Magazzino (Senza Reso)",
                confirm_cancel_title: "Segna come Errore/Reso",
                confirm_wastage_title: "Segna come Spreco",
                confirm_cancel_text: "Questo annullerà la vendita e ripristinerà tutte le scorte in inventario. Sei sicuro?",
                confirm_wastage_text: "Questo annullerà la vendita ma la merce sarà considerata USATA/PERSA. Sei sicuro?",
                confirm: "CONFERMA"
            }
        },
        pos: {
            title_quick: "Ordine Rapido",
            title_no_table: "Senza Tavolo",
            title_table: "{{name}}",
            search_placeholder: "Cerca Prodotto...",
            grid: {
                sold_out: "ESAURITO"
            },
            ticket: {
                title: "Scontrino Corrente",
                order_no: "ORDINE N.",
                new: "NUOVO",
                empty: "Il carrello è vuoto.",
                status: {
                    wastage: "SPRECO",
                    comp: "OMAGGIO",
                    cancelled: "ANNULLATO",
                    paid: "PAGATO"
                },
                discount_badge: "SCONTO"
            },
            actions: {
                discount: "SCONTO",
                comp: "OMAGGIO",
                void: "SPRECO",
                cancel: "ANNULLA",
                pay: "PAGA",
                assign_table: "TAVOLO",
                save: "SALVA",
                waiting_payment: "ATTESA PAGAMENTO",
                close_ticket: "CHIUDI SCONTRINO"
            },
            totals: {
                subtotal_net: "Subtotale (Netto)",
                tax_vat: "Tasse (IVA)",
                grand_total: "Totale Complessivo",
                tax_exclusive_hint: "(+Tasse)"
            },
            alerts: {
                table_not_found: "Tavolo non trovato.",
                perm_comp: "Non hai il permesso di offrire omaggi.",
                perm_void: "Non hai il permesso di stornare articoli.",
                select_item_error: "Seleziona un articolo.",
                paid_item_error: "Gli articoli pagati non possono essere modificati.",
                split_quantity: "Quanti di {{count}} articoli vuoi spostare?",
                invalid_amount: "Importo non valido.",
                perm_discount: "Non hai il permesso di applicare sconti.",
                select_discount_item: "Seleziona un articolo da scontare.",
                paid_discount_error: "Impossibile scontare articoli pagati.",
                add_items_first: "Aggiungi prima gli articoli al carrello.",
                unauthorized: "Accesso Negato"
            },
            modifier_modal: {
                no_modifiers: "Nessuna variante disponibile.",
                multiple: "multiplo",
                add_to_cart: "Aggiungi al Carrello"
            },
            discount_modal: {
                title: "Applica Sconto",
                percent: "Percentuale",
                amount: "Importo",
                comp_100: "OMAGGIO (100%)",
                old_total: "Vecchio Totale",
                new_total: "Nuovo Totale",
                apply: "Applica Sconto"
            }
        },
        payment: {
            alerts: {
                enter_valid: "Inserisci un importo valido.",
                balance_not_zero: "Il saldo rimanente deve essere 0 per chiudere lo scontrino."
            },
            header_order: "Ordine",
            header_open: "Scontrino Aperto",
            ticket_details: "Dettagli Scontrino",
            select_all: "Seleziona Tutto",
            items_count: "{{count}} Articoli",
            empty_list: "Nessun Articolo",
            remaining_badge: "Rimanente: {{amount}}",
            recent_transactions: "TRANSAZIONI RECENTI",
            totals: {
                total: "Totale",
                paid: "Pagato",
                remaining: "Rimanente"
            },
            amount_to_collect: "Importo da Riscuotere",
            give_change: "Resto",
            return_to_customer: "Restituisci al Cliente",
            methods: {
                cash: "Contanti",
                card: "Carta di Credito",
                qr: "QR / Mobile",
                other: "Ticket Restaurant"
            },
            numpad: {
                all: "Tutto"
            },
            actions: {
                cancel: "Annulla",
                close_ticket: "Chiudi Scontrino",
                waiting_payment: "Attesa Pagamento"
            }
        },
        menu: {
            title: "Gestione Menu",
            subtitle: "Gestisci prodotti, prezzi e scorte",
            add_new: "Aggiungi Prodotto",
            edit_title: "Modifica Prodotto",
            add_title: "Aggiungi Prodotto",
            manage_categories: "Gestisci Categorie",
            alerts: {
                no_permission: "Non hai il permesso di gestire il menu.",
                delete_confirm: "Sei sicuro di voler eliminare questo prodotto?"
            },
            form: {
                image_select: "Seleziona Immagine",
                image_change: "Cambia Immagine",
                image_recommendation: "Formato quadrato raccomandato",
                image_max_size: "Max 2MB",
                name: "Nome Prodotto",
                name_placeholder: "es. Latte Macchiato",
                category: "Categoria",
                price: "Prezzo",
                stock_tracking: "Tracciamento Scorte",
                stock_hint: "Lascia 0 per disabilitare",
                description: "Descrizione",
                description_placeholder: "Ingredienti, dettagli...",
                customizable: "Personalizzabile (Varianti)"
            },
            categories: {
                title: "Gestione Categorie",
                add: "Aggiungi Categoria",
                name: "Nome Categoria",
                edit: "Modifica Categoria",
                delete_confirm: "Eliminare questa categoria?"
            }
        },
        categories: {
            all: "Tutti",
            hot_coffees: "Caffè Caldi",
            cold_coffees: "Caffè Freddi",
            desserts: "Dolci",
            snacks: "Snack",
            barista_special: "Speciali"
        },
        stock: {
            title: "Gestione Inventario",
            subtitle: "Scorte, Ricette e Varianti",
            tabs: {
                inventory: "Inventario",
                recipes: "Ricette",
                modifiers: "Varianti"
            },
            inventory: {
                total_value: "Valore Totale",
                sku_count: "Conteggio SKU",
                alerts: "Avvisi Scorte",
                search_placeholder: "Cerca Scorte...",
                add_stock: "Aggiungi Articolo",
                status_critical: "Critico",
                status_warning: "Basso",
                status_sufficient: "OK",
                table: {
                    name: "Nome",
                    supplier: "Fornitore",
                    amount: "Quantità",
                    status: "Stato",
                    unit_cost: "Costo Unitario",
                    actions: "Azioni"
                },
                modal: {
                    edit_title: "Modifica Scorta",
                    add_title: "Aggiungi Scorta",
                    general_info: "Info Generali",
                    management: "Gestione",
                    name: "Nome Articolo",
                    name_placeholder: "es. Latte",
                    supplier: "Fornitore",
                    supplier_placeholder: "es. Azienda Agricola Locale",
                    unit: "Unità",
                    alarm_thresholds: "Soglie di Allarme",
                    warning_limit: "Limite Avviso",
                    critical_limit: "Limite Critico",
                    stock_status: "Stato Scorte",
                    finish_editing: "Termina Modifica",
                    manual_correction: "Correzione Manuale",
                    current_amount: "Quantità Attuale",
                    unit_cost: "Costo Unitario",
                    new_purchase: "Nuovo Acquisto / Ingresso",
                    add_amount: "Aggiungi Quantità",
                    purchase_price: "Prezzo d'Acquisto",
                    total: "Totale",
                    unit_price: "Prezzo Unitario",
                    success_feedback: "Aggiornato!",
                    calculate_add: "Calcola e Aggiungi",
                    avg_cost_note: "* Calcola il costo medio ponderato."
                }
            },
            wastage: {
                title: "Segnala Spreco",
                subtitle: "Segnalazione spreco per {{name}}",
                amount: "Quantità",
                reason: "Motivo",
                reason_placeholder: "es. Rovesciato, Scaduto",
                report: "Invia Segnalazione"
            },
            recipes: {
                search_product: "Cerca prodotto...",
                gross_margin: "Margine Lordo",
                sale_price: "Prezzo di Vendita",
                cost_price: "Prezzo di Costo",
                ingredients: "Ingredienti",
                no_recipe: "Nessuna ricetta definita.",
                add_ingredient: "Aggiungi Ingrediente",
                stock_item: "Articolo di Magazzino",
                amount: "Quantità",
                unit: "Unità"
            },
            modifiers: {
                title: "Gruppi Varianti",
                new_group: "Nuovo Gruppo",
                group_name: "Nome Gruppo",
                selection_type: "Tipo di Selezione",
                single: "Singola (Radio)",
                multiple: "Multipla (Checkbox)",
                options: "Opzioni",
                option_name: "Nome Opzione",
                option_placeholder: "es. Latte d'Avena",
                extra_price: "Prezzo Extra",
                deduct_stock: "Scarica Magazzino (Opzionale)",
                add_option: "Aggiungi Opzione",
                group_helper_text: "Gestisci le opzioni per questo gruppo qui sotto.",
                no_link: "Nessun Collegamento",
                stock_optional_label: "Magazzino (Opzionale)",
                edit_group_title: "Modifica Gruppo",
                allow_multiple_label: "Consenti selezioni multiple (Checkbox)",
                delete_group_confirm: "Sei sicuro di voler eliminare questo gruppo?"
            }
        },
        reports: {
            title: "Panoramica Finanziaria",
            filters: { today: "Oggi", week: "Settimana", month: "Mese", all: "Tutti" },
            kpi: {
                revenue: "Entrate Totali",
                net_revenue: "Entrate Nette (Senza Tasse)",
                tax_collected: "Tasse Raccolte",
                income: "Incassi",
                expense: "Spese Totali",
                expense_opr: "Operative",
                expense_stock: "COGS (Costo Merce)",
                expense_wastage: "Spreco",
                profit: "Utile Netto",
                profit_opr: "Utile Operativo",
                cash_in_hand: "Flusso di Cassa",
                gross_profit: "Utile Lordo",
                tickets: "Totale Scontrini",
                sales_count: "Conteggio Vendite",
                expense_analysis: "Analisi Spese",
                profit_analysis: "Analisi Utile Netto",
                available_in_standard: "Disponibile nel Piano Standard",
                locked: "Bloccato"
            },
            toggles: {
                stock_cost: "Costo Scorte",
                wastage: "Spreco",
                operational: "Modalità Operativa",
                net_revenue: "Entrate Nette (Tasse)"
            },
            charts: {
                sales_title: "Grafico Vendite ({{currency}})",
                hourly: "Orario",
                daily: "Giornaliero",
                monthly: "Mensile",
                distribution: "Distribuzione",
                category_breakdown: "Suddivisione Categorie",
                revenue_share: "Quota Entrate",
                no_data: "Nessun dato.",
                tooltip_revenue: "Entrate: ",
                tooltip_net_revenue: "Entrate Nette: ",
                tooltip_profit: "Utile: "
            },
            transactions: {
                title: "Cronologia Transazioni",
                count_listed: "{{count}} Record Elencati",
                table: {
                    ticket_no: "Scontrino N.",
                    date: "Data / Ora",
                    table: "Tavolo",
                    method: "Metodo",
                    amount: "Importo",
                    status: "Stato"
                },
                status: {
                    completed: "Completato",
                    cancelled: "Annullato"
                },
                no_records: "Nessuna transazione trovata nell'intervallo selezionato."
            },
            x_report: {
                title: "Rapporto Istantaneo di Cassa (Rapporto X)",
                total_cash: "Totale Contanti in Cassa",
                daily_tickets: "Scontrini Giornalieri",
                cancelled_trx: "Transazioni Annullate",
                collections: "Incassi (Correnti)",
                shift_reports: "Rapporti Turni Personale (Oggi)",
                no_shift: "Nessun rapporto turno ancora disponibile.",
                total_sales: "VENDITE TOTALI",
                cash: "Contanti",
                credit_card: "Carta di Credito",
                qr_mobile: "QR / Mobile",
                meal_card: "Ticket Restaurant"
            },
            z_report: {
                title: "Rapporto di Chiusura Giornaliera (Rapporto Z)",
                auto_toggle: "Rapporto Z Automatico",
                auto_desc: "Alle 00:00",
                close_button: "CHIUDI GIORNATA (RAPPORTO Z)",
                history_title: "Rapporti Z Passati",
                no_reports: "Nessun rapporto ancora disponibile.",
                receipt: {
                    title: "RAPPORTO Z",
                    report_no: "Rapporto N.",
                    cashier: "Cassiere",
                    total_sales: "VENDITE TOTALI",
                    tax_base: "Imponibile",
                    total_tax: "Totale Tasse",
                    payment_details: "Dettagli Pagamento",
                    cash: "Contanti",
                    card: "Carta di Credito",
                    other: "Altro",
                    end: "--- FINE ---"
                }
            },
            modals: {
                close_confirm: {
                    title: "Chiudere Giornata?",
                    text: "Questa azione archivierà <strong>{{count}}</strong> transazioni aperte e genererà un Rapporto Z ufficiale. L'azione non può essere annullata.",
                    cancel: "Annulla",
                    confirm: "Conferma e Chiudi"
                },
                expense: {
                    title: "Aggiungi Spesa Rapida",
                    date: "Data",
                    category: "Categoria",
                    amount: "Importo",
                    description: "Descrizione",
                    optional: "Opzionale...",
                    set_default: "Imposta come predefinito per la categoria",
                    last_trx: "Ultima: {{amount}} ({{date}})"
                },
                processing: {
                    title: "Generazione Rapporto Z...",
                    text: "Attendere, elaborazione chiusura giornata in corso..."
                }
            },
            liabilities: {
                pending: "Pagamenti in Sospeso",
                label_today: "Quota Spese Oggi",
                label_week: "Quota Spese Settimanale",
                label_total: "Pagamenti Ricorrenti in Sospeso"
            }
        },
        settings: {
            general: "Impostazioni Generali",
            titles: {
                general: "Generale",
                expenses: "Spese",
                modifiers: "Varianti",
                developer: "Sviluppatore"
            },
            descriptions: {
                general: "Impostazioni di sistema, lingua e business",
                expenses: "Configurazione finanziaria",
                developer: "Strumenti per simulazione e test"
            },
            subscription: {
                active: "ATTIVO",
                inactive: "NON ATTIVO",
                expired: "SCADUTO",
                renew: "Rinnova",
                days_left: "Giorni Rimasti",
                next_payment: "Prossimo Pagamento",
                period_start: "Inizio Periodo",
                time_remaining: "Tempo Rimanente",
                lite_plan: "Piano Lite",
                standard_plan: "Piano Standard"
            },
            business_identity: "Identità Aziendale",
            financial: "Impostazioni Finanziarie",
            financial_desc: {
                currency_desc: "Simbolo utilizzato in tutto il sistema",
                pricing_desc: "Metodo di calcolo delle tasse"
            },
            interface: {
                title: "Interfaccia",
                scale: "Scala UI (Zoom)",
                scale_desc: "Regola la scala per gli elementi che non si adattano o appaiono troppo piccoli/grandi.",
                note: "Nota:",
                scale_note: "L'auto-scaling è sempre attivo su schermi inferiori a 1366px."
            },
            operational: {
                title: "Orari di Lavoro e Turni",
                start_hour: "Ora Inizio (0-23)",
                end_hour: "Ora Fine (0-23)",
                info_text: "Questa impostazione determina l'intervallo temporale mostrato nel grafico delle vendite orarie della **Dashboard**. Viene utilizzata anche come riferimento per il reporting dei turni del personale.",
                updated_alert: "Orari di lavoro aggiornati."
            },
            shortcuts: {
                staff_desc: "Gestisci Camerieri, Baristi e Admin"
            },
            backup: {
                title: "Dati e Backup",
                backup_now: "Backup",
                backup_desc: "Scarica Database (.json)",
                restore: "Ripristina",
                restore_desc: "Seleziona File .json",
                factory_reset: "Ripristino di Fabbrica",
                reset_desc: "Tutti i dati verranno cancellati e il sistema tornerà allo stato iniziale.",
                reset_button: "Resetta Dati",
                success_restore: "Backup ripristinato con successo."
            },
            security: {
                reset_title: "Ripristino di Fabbrica",
                restore_title: "Ripristina da Backup",
                reset_text: "Questa azione non può essere annullata. Tutti i dati (vendite, prodotti, scorte) verranno eliminati permanentemente.",
                restore_text: "I dati attuali verranno eliminati e verranno caricati i dati dal file di backup selezionato.",
                admin_required: "Approvazione Admin Richiesta",
                enter_pin: "Inserisci PIN",
                confirm_reset: "Elimina e Resetta",
                confirm_restore: "Avvia Ripristino"
            },
            messages: {
                updated: "Impostazioni aggiornate.",
                error: "Si è verificato un errore."
            },
            sync: {
                title: "Sincronizzazione Cloud",
                pending: "{{count}} elementi in attesa",
                up_to_date: "Tutti i dati sono aggiornati",
                button: "Sincronizza Ora"
            }
        },
        financials: {
            title: "Impostazioni Finanziarie",
            subtitle: "Aliquote Fiscali e Categorie di Spesa",
            tabs: {
                taxes: "Tasse",
                expenses: "Spese",
                history: "Cronologia Spese"
            },
            taxes: {
                title: "Aliquote Fiscali",
                active_rates: "Aliquote Attive",
                rate_name: "Nome Aliquota",
                rate_percent: "Aliquota %",
                description: "Descrizione",
                add_new: "Aggiungi Nuova Aliquota",
                category_mapping: "Mappatura Tasse per Categoria"
            },
            expenses: {
                title: "Categorie di Spesa",
                add_new: "Aggiungi Categoria",
                category_name: "Nome Categoria",
                description: "Descrizione",
                default_amount: "Importo Predefinito",
                recurring: "Ricorrente (Mensile)",
                recurring_day: "Giorno del Mese",
                distribute_daily: "Distribuisci Giornalmente nei Rapporti"
            },
            history: {
                title: "Cronologia Spese",
                filter_all: "Tutte le Categorie",
                no_records: "Nessun record trovato.",
                table: {
                    date: "Data",
                    category: "Categoria",
                    description: "Descrizione",
                    amount: "Importo"
                }
            }
        },
        crm: {
            title: "CRM e Fedeltà",
            subtitle: "Gestione Clienti e Programma Fedeltà",
            give_points: "Assegna Punti",
            qr_instruction: "Scansiona codice QR per il cliente",
            generate_qr: "Genera QR",
            qr_description: "Mostra questo codice QR al cliente per aggiungere punti al suo wallet.",
            customer_list: "Lista Clienti",
            search_placeholder: "Cerca Cliente...",
            last_visit: "Ultima Visita:",
            eligible: "Premio Disponibile!",
            settings_title: "Impostazioni Campagna",
            target_points: "Punti Obiettivo",
            reward_name: "Nome Premio",
            preview: "Anteprima Carta",
            target_label: "Obiettivo",
            coming_soon: "In arrivo"
        },
        qr: {
            title: "Menu QR",
            subtitle: "Menu Digitale e Sistema di Ordinazione",
            simulate: "Simula Ordine",
            print_selected: "Stampa Selezionati",
            lock: {
                title: "Servizi Online Bloccati",
                desc: "Il Menu QR e le funzioni di ordinazione online sono disponibili nel Piano Standard.",
                upgrade_btn: "Migliora Piano"
            },
            print: {
                title: "Stampa Codici QR",
                scan_instruction: "Scansiona per visualizzare il Menu"
            },
            preview: {
                title: "Anteprima Live",
                network: "Rete:",
                password: "Pass:",
                powered_by: "Powered by KahveInn",
                disclaimer: "* Questa è un'anteprima di come apparirà il supporto QR.",
                scan_instruction: "Scansiona per il Menu"
            },
            settings: {
                general: "Generale",
                active: "Attivo",
                active_desc: "Abilita sistema Menu QR",
                ordering: "Consenti Ordinazione",
                ordering_desc: "I clienti possono effettuare ordini",
                sound: "Avviso Sonoro",
                sound_desc: "Riproduci suono per ogni nuovo ordine",
                design: "Design",
                header_text: "Testo Intestazione",
                theme_color: "Colore Tema",
                wifi_ssid: "SSID Wi-Fi",
                wifi_pass: "Password Wi-Fi"
            },
            selection: {
                title: "Selezione Tavolo",
                select_all: "Seleziona Tutto",
                previewing: "Anteprima in corso"
            },
            modal: {
                permission_title: "Permesso Richiesto",
                permission_text: "Abbiamo bisogno del permesso del browser per riprodurre le notifiche sonore.",
                allow_btn: "Consenti Suono"
            }
        },
        staff: {
            title: "Gestione Personale",
            subtitle: "Dipendenti e autorizzazioni",
            tabs: {
                list: "Lista Personale",
                roles: "Ruoli e Permessi"
            },
            lite_banner: {
                title: "Piano Lite",
                desc: "La gestione avanzata del personale è limitata."
            },
            stats: {
                total: "Totale Personale",
                on_duty: "In Servizio"
            },
            matrix: {
                person: "Persona"
            },
            auto_shift_report: "Rapporto Turno Automatico",
            modal: {
                add_title: "Aggiungi Personale",
                edit_title: "Modifica Personale",
                delete: "Elimina Personale",
                name: "Nome Completo",
                role: "Ruolo",
                pin: "Codice PIN (4 cifre)",
                phone: "Telefono (Opzionale)",
                status: "Stato",
                status_working: "In Servizio",
                status_off: "Fuori Servizio"
            },
            roles_tab: {
                title: "Ruoli",
                subtitle: "Personalizza i permessi dei ruoli",
                permissions: "Permessi",
                no_permissions: "Nessun permesso assegnato"
            },
            contact: "Contatto",
            status: {
                working: "In Servizio",
                offline: "Fuori Servizio"
            },
            permission_matrix: "Matrice Permessi",
            no_pin_permission: "Nessun permesso per visualizzare/cambiare il PIN",
            unauthorized_tooltip: "Non puoi modificare questo utente",
            alerts: {
                no_add_permission: "Non hai il permesso di aggiungere personale.",
                no_edit_others: "Puoi modificare solo il tuo profilo.",
                no_edit_admin: "Solo gli Admin possono modificare gli Admin.",
                no_delete_self: "Non puoi eliminare te stesso.",
                no_delete_permission: "Non hai il permesso di eliminare il personale.",
                no_delete_admin: "Solo gli Admin possono eliminare gli Admin.",
                delete_confirm: "Sei sicuro di voler eliminare questo membro dello staff?",
                no_status_admin: "Solo gli Admin possono cambiare lo stato degli Admin.",
                only_admin_roles: "Solo gli Admin possono cambiare i permessi dei ruoli."
            }
        },
        permission_groups: {
            general: "Generale",
            sales: "Vendite",
            management: "Gestione"
        },
        permissions: {
            VIEW_FINANCIALS: { label: "Visualizza Finanze", description: "Accesso ai dati su entrate e utili" },
            VIEW_TABLES: { label: "Visualizza Tavoli", description: "Visualizza piano tavoli e ordini" },
            MANAGE_MENU: { label: "Gestisci Menu", description: "Aggiungi e modifica prodotti" },
            MANAGE_STOCK: { label: "Gestisci Magazzino", description: "Controllo inventario" },
            VIEW_REPORTS: { label: "Visualizza Rapporti", description: "Accesso alle pagine dei rapporti" },
            MANAGE_STAFF: { label: "Gestisci Personale", description: "Aggiungi/rimuovi personale" },
            MANAGE_SETTINGS: { label: "Gestisci Impostazioni", description: "Configurazione di sistema" },
            VOID_ITEM: { label: "Storna Articolo", description: "Operazioni di annullamento o spreco" },
            OFFER_COMP: { label: "Offri Omaggio", description: "Permesso di dare articoli gratuitamente" },
            APPLY_DISCOUNT: { label: "Applica Sconto", description: "Applica sconto all'ordine" },
            CLOSE_DAY: { label: "Chiudi Giornata", description: "Permesso di emettere il Rapporto Z" }
        },
        setup: {
            business_name: "Nome Azienda",
            business_address: "Indirizzo",
            manager_name: "Nome Manager",
            manager_hint: "Il tuo nome per il profilo manager",
            staff_count: "Numero Personale",
            staff_hint: "Numero stimato di dipendenti",
            currency: "Valuta",
            pricing_model: "Modello di Prezzo",
            tax_inclusive: "Tasse Incluse",
            tax_exclusive: "Tasse Escluse",
            completing: "Completamento Setup...",
            title_1: "Benvenuto",
            title_2: "Team e Gestione",
            title_3: "Impostazioni Finanziarie",
            desc_1: "Creiamo l'identità della tua azienda.",
            desc_2: "Configuriamo la struttura del tuo team.",
            desc_3: "Seleziona la tua valuta e le preferenze fiscali.",
            skip_dev: "Salta (Dev)",
            back: "Indietro",
            next: "Avanti",
            finish: "Termina Setup",
            placeholders: {
                business_name: "es. KahveInn",
                city: "Città (es. Milano)",
                district: "Quartiere/Zona",
                address_detail: "Via, Numero Civico...",
                manager_name: "Il tuo nome completo"
            },
            errors: {
                business_name: "Inserisci il nome dell'azienda.",
                city: "Inserisci la città.",
                district: "Inserisci il quartiere.",
                address_detail: "Inserisci l'indirizzo completo.",
                manager_name: "Inserisci il nome del manager.",
                staff_count: "Inserisci un numero di personale valido."
            },
            currencies: {
                try: "Lira Turca (₺)",
                usd: "Dollaro Statunitense ($)",
                eur: "Euro (€)",
                gbp: "Sterlina Britannica (£)"
            },
            loading_text: "Il sistema è in preparazione, attendere prego."
        }
    }
};